import React, { Component } from 'react'
import '../css/dataTables.css';
import $ from 'jquery';
import Select from 'react-select';

const headers = [
    { title: 'Folio' },
    { title: 'Documento' },
    { title: 'Fecha' },
    { title: 'Días de atraso' },
    { title: 'Total' },
    { title: 'N° doc.' },
];

class TransferRouteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInTable: '',
        }
    }

    componentDidMount() {
        const { cleanData } = this.props;

        this.CloseAction();
    }

    CloseModal = async () => {
        $('#TransferRouteModal').modal('hide');
    };

    CloseAction = () => {
        // const { cleanData } = this.props;
        $('#TransferRouteModal').on('hidden.bs.modal', () => {
            // cleanData();
        });
    };


    AddLinesToDocument = () => {
        $('#TransferRouteModal').modal('hide');

    }

    OnchangeDriver = async (index, type = null) => {
        const { RouteDoc, Drivers, RefreshModel } = this.props
        const indexNumber = Number(index);

        if (indexNumber === -1) {
            RouteDoc.IdVDRVTransfer = '';
            RouteDoc.NameDriverTransfer = '';
            RouteDoc.AuxIndexDriverTransfer = indexNumber;
            RefreshModel(RouteDoc);
        } else {
            RouteDoc.IdVDRVTransfer = Drivers[index].value;
            RouteDoc.NameDriverTransfer = Drivers[index].label;
            RouteDoc.AuxIndexDriverTransfer = index;
            RefreshModel(RouteDoc);
        }

    }
    OnchangeVehicle = (value) => {
        const { RouteDoc, RefreshModel, showAlert, Drivers } = this.props
        if ((value?.value ?? null) == RouteDoc.CodigoAutotransporte) {
            return showAlert({ type: 'error', message: 'El código debe ser distinto al asignado' })
        }
        RouteDoc.CodigoAutotransporteTransfer = (value?.value ?? null);
        RouteDoc.pk_Sucursal = (value?.pk_Sucursal ?? null);
        RefreshModel(RouteDoc);

        if (value) {
            const idxFigTransp = Drivers?.findIndex(driver => Number(driver?.value ?? -2) === Number(value?.U_FMB_Driver ?? -1));
            this.OnchangeDriver(idxFigTransp)
            if (idxFigTransp === -1) {
                showAlert({ type: 'error', message: "Este Vehículo no tiene una figura de transporte relacionada" });
                RouteDoc.CodigoAutotransporteTransfer = null
            }
        } else {
            this.OnchangeDriver(-1)
            RouteDoc.CodigoAutotransporteTransfer = null
        }
    }

    transferRoute = () => {
        const { SendModel, RouteDoc, showAlert } = this.props
        const hasSelected = RouteDoc.DocsLines.some(
            line => line.transferLine
        );
        if (!hasSelected) {
            return showAlert({ type: 'error', message: 'Seleccione al menos un documento para transferir' })
        }
        if (RouteDoc.CodigoAutotransporteTransfer == null) {
            return showAlert({ type: 'error', message: 'Seleccione un transporte válido' })
        }
        if (RouteDoc.CodigoAutotransporteTransfer == RouteDoc.CodigoAutotransporte) {
            return showAlert({ type: 'error', message: 'El código debe ser distinto al asignado' })
        }


        this.CloseModal()
        SendModel()

    }

    ChangeTransferLine = (index) => {
        const { RefreshModel, RouteDoc } = this.props
        RouteDoc.DocsLines[index].transferLine = !RouteDoc.DocsLines[index].transferLine
        RefreshModel(RouteDoc);
    }
    SelectAll = () => {
        const { RouteDoc, RefreshModel } = this.props;
        const hasUnselected = RouteDoc.DocsLines.some(
            line => !line.transferLine && (line?.Transfered ?? 'N') != 'Y'
        );
        const updatedLines = RouteDoc.DocsLines.map(line => ({
            ...line,
            transferLine: (line?.Transfered ?? 'N') == 'Y' ? false : hasUnselected
        }));
        RouteDoc.DocsLines = updatedLines
        RefreshModel(RouteDoc);
    };

    render() {
        const { Vehicles, RouteDoc, Drivers } = this.props;
        const noTransferLine = RouteDoc.DocsLines.find(line => !line.transferLine && (line?.Transfered ?? 'N') != 'Y')
        let allSelected = true;
        if (noTransferLine) {
            allSelected = false
        }

        return (
            <div className="modal fade bd-example-modal-xl scroll bgtransparent" role="dialog" id="TransferRouteModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">TRANSFERIR RUTA</h4>
                            <button type="button" className="close" onClick={this.CloseModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Chofer</span>
                                            </div>
                                            <Select
                                                options={Drivers ?? []}
                                                value={Drivers?.find(opt => opt.value === RouteDoc?.IdVDRV ?? '') || null}
                                                onChange={() => { }}
                                                placeholder="Escribe para buscar chofer"
                                                isDisabled={true}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={{
                                                    container: (base) => ({ ...base, flex: 1 }),
                                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                    singleValue: (base) => ({ ...base, color: "#000" })
                                                }}
                                            />
                                        </div>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Vehículo Origen</span>
                                            </div>

                                            <Select
                                                options={Vehicles ?? []}
                                                value={Vehicles?.find(opt => opt.value === RouteDoc?.CodigoAutotransporte ?? '') || null}
                                                onChange={() => { }}
                                                placeholder="Escribe para buscar vehiculo"
                                                isDisabled={true}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={{
                                                    container: (base) => ({ ...base, flex: 1 }),
                                                    // control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                    singleValue: (base) => ({ ...base, color: "#000" })
                                                }}
                                            />
                                        </div>

                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Chofer</span>
                                            </div>
                                            <Select
                                                options={Drivers ?? []}
                                                value={Drivers?.find(opt => opt.value === RouteDoc?.IdVDRVTransfer ?? '') || null}
                                                // onChange={this.changeChofer}
                                                placeholder="Escribe para buscar chofer"
                                                isDisabled={true}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={{
                                                    container: (base) => ({ ...base, flex: 1 }),
                                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                    singleValue: (base) => ({ ...base, color: "#000" })
                                                }}
                                            />
                                        </div>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Vehículo Destino</span>
                                            </div>
                                            <Select
                                                options={Vehicles ?? []}
                                                value={Vehicles?.find(opt => opt.value === RouteDoc?.CodigoAutotransporteTransfer ?? '') || null}
                                                onChange={this.OnchangeVehicle}
                                                placeholder="Escribe para buscar vehiculo"
                                                isDisabled={false}
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={{
                                                    container: (base) => ({ ...base, flex: 1 }),
                                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                    singleValue: (base) => ({ ...base, color: "#000" })
                                                }}
                                            />

                                        </div>

                                    </div>
                                </div>
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="tab-pane active">
                                            <div className="w-100 table-scroll tab-pane " style={{ textAlign: 'center' }}>
                                                <table id="dataTableDocuments" className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000, tableLayout: 'auto', maxHeight: '400px', overflowY: 'auto' }}>
                                                    <thead className="table-header-yellow">
                                                        <tr>
                                                            <td className="sticky-header1 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={() => this.SelectAll()}
                                                                    style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                                                    checked={allSelected}
                                                                />
                                                            </td>
                                                            <td className="sticky-header1 text-center"> DOCUMENTO </td>
                                                            <td className="sticky-header1 text-center"> CLIENTE </td>
                                                            <td className="sticky-header1 text-center"> DIRECCION </td>
                                                            <td className="sticky-header1 text-center"> CANTIDAD </td>
                                                            <td className="sticky-header1 text-center"> ARTÍCULO </td>
                                                            <td className="sticky-header1 text-center"> DESCRIPCION </td>
                                                            {/* <td className="sticky-header1 text-center"> PRIORIDAD </td> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {RouteDoc && RouteDoc.DocsLines && RouteDoc.DocsLines.length > 0 &&
                                                            RouteDoc.DocsLines.filter(routeLine => (routeLine?.Transfered ?? 'N') === 'N' && ((routeLine?.ProcessStatus ?? '') == 'Assigned' || (routeLine?.ProcessStatus ?? '') == 'Charged')).map((routeLine, indexLine) =>
                                                                <tr >

                                                                    {(routeLine?.Transfered ?? 'N') === 'Y' ? <td>Transferido</td> :
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => this.ChangeTransferLine(indexLine)}
                                                                            style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                                                            checked={routeLine.transferLine}
                                                                        />
                                                                    }

                                                                    <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {routeLine?.NumAtCard || routeLine?.DocNum || ""} </td> {/* FOLIO / DOCNUM */}

                                                                    <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '200px', maxWidth: '200px', minWidth: '200px' }}> {routeLine?.CardName || ""} </td> {/* SOCIO */}
                                                                    <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '200px', maxWidth: '200px', minWidth: '200px' }}> {routeLine?.AddressDesc || ""} </td> {/* DIRECCION */}

                                                                    <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {Number(routeLine?.Quantity || 0).toFixed(3)} </td> {/* CANTIDAD */}
                                                                    <td style={{ whiteSpace: 'nowrap', wordBreak: 'center' }}> {routeLine?.ItemCode || ""} </td> {/* ARTÍCULO */}
                                                                    <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}> {routeLine?.ItemName || ""} </td> {/* DESCRIPTION */}
                                                                    {/* PRIORIDAD DE ENTREGA */}
                                                                    {/* <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                                        <select
                                                                            className="form-control"
                                                                            disabled={true}
                                                                            value={routeLine?.Priority ?? 1}
                                                                            onChange={(event) => this.ChangePriorityLine(event.target.value, indexLine)}
                                                                            style={{
                                                                                width: 'auto',
                                                                                minWidth: '90px',
                                                                                display: 'inline-block'
                                                                            }} >
                                                                            <option value={3}>ALTA</option>
                                                                            <option value={2}>MEDIA</option>
                                                                            <option value={1}>BAJA</option>
                                                                        </select>
                                                                    </td> */}

                                                                </tr>
                                                            )
                                                        }


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.CloseModal}>Cerrar</button>
                            {/* {RouteDoc.TransferRoute === null && */}
                            <button type="button" className="btn botonCorrect" onClick={() => this.transferRoute()}>Transferir</button>
                            {/* } */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default TransferRouteModal;